module.exports = __webpack_public_path__ + "img/5.ed20aada.png";